import React, { useEffect } from "react";

import classes from "./DealerCard.module.css";
import { participantInfo } from "./utils";

const DealerCard = ({ chat, userId }) => {
  let dealer = null,
    participantName = null;

  if (chat) {
    participantName = participantInfo(chat, userId).participantName;
  }

  dealer = (
    <div className={classes.DealerCard}>
      <h1>{participantName ?? "User"}</h1>
    </div>
  );

  return <div className={classes.Container}>{dealer}</div>;
};

export default DealerCard;
